<template>
  <div
    class="container-fluid w-100 h-100"
    style="overflow-x: hidden"
  >
    <navbar
      :title="$t('street_lights.title')"
      class="mb-1"
    />
    <div class="nopads">
      <!-- Tabs for browsing -->
      <ul
        class="nav nav-tabs routa-tabs"
        role="tablist"
      >
        <li class="nav-item">
          <button
            class="routa-tab"
            :class="{ active: tabIndex === 0 }"
            :style="linkTabClass(0)"
            @click="tabIndex = 0"
          >
            {{ $t('street_lights.title') }}
          </button>
        </li>
        <li class="nav-item">
          <button
            class="routa-tab"
            :class="{ active: tabIndex === 1 }"
            :style="linkTabClass(1)"
            @click="tabIndex = 1"
          >
            {{ $t('power_stations.title') }}
          </button>
        </li>
        <li class="nav-item">
          <button
            class="routa-tab"
            :class="{ active: tabIndex === 2 }"
            :style="linkTabClass(2)"
            @click="tabIndex = 2"
          >
            {{ $t('cables.title') }}
          </button>
        </li>
      </ul>
      <!-- Tab contents -->
      <div class="tab-content routa-tab-content">
        <div
          v-show="tabIndex === 0"
          class="tab-pane fade show active"
        >
          <street-lights :user="user" />
        </div>
        <div
          v-show="tabIndex === 1"
          class="tab-pane fade show active"
        >
          <power-stations :user="user" />
        </div>
        <div
          v-show="tabIndex === 2"
          class="tab-pane fade show active"
        >
          <cables :user="user" />
        </div>
      </div>
    </div>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {restApi} from '@/components/mixins/RestApiMixin'
import {userHelper} from "@/components/mixins/UserMixin";
import StreetLights from "@/components/streetlights/StreetLights";
import PowerStations from "@/components/streetlights/PowerStations";
import Cables from "@/components/streetlights/Cables";
import Navbar from "@/components/utils/Navbar";

export default {
    name: 'StreetLightsView',
    components: {
        Navbar,
        Cables,
        PowerStations,
        StreetLights
    },
    mixins: [restApi,userHelper],
    props: {
        user: {
            type: Object,
            default: null
        },
    },
    data: function () {
        return {
            loading: false,
            tabIndex: 0
        }
    },
    methods: {
        linkTabClass(index) {
            if (this.tabIndex === index) {
                return ['tab-title', 'tab-title-active']
            } else {
                return ['tab-title']
            }
        }
    }
}
</script>

<style>
.tab-title {
    font-size: .9em;
    border: none !important;
    margin-right: .5em;
    margin-left: .5em;
    color: #949494 !important;
    font-weight: bold;
}

.tab-title:hover {
    color: #007BFF;
}

.tab-title-active {
    border-bottom: 2px solid #7FC000 !important;
}

.tab-title-text {
    color: #949494 !important;
    font-weight: bold;
}


.tab-title-text-active {
    color: #000000 !important;
    font-weight: bold;
}


.tab-title-cont {
    height: 2.5em !important;
    padding-top: 1em;
    padding-bottom: 1em;
}

.contract-tabs .nav-link {
    display: flex !important;
    justify-content: center;
    align-items: center;
}

.contract-tabs .nav-tabs {
    height: 3em;
    padding-top: .55em;
}

</style>
